export default __webpack_public_path__ + "static/media/cv-default.691dba30.svg";